import { IPickerOption, MenuObject } from '@rbi-ctg/menu';
import { MenuObjectTypes } from 'enums/menu';

export const buildEntitiesWithBadgeMap = (menu: MenuObject[], requirementsSet: Set<string>) => {
  return (menu || []).reduce((menuIds: Set<string>, menuObject: MenuObject) => {
    (menuObject?.options || []).forEach(option => {
      if (
        (option._type === MenuObjectTypes.ITEM || option._type === MenuObjectTypes.COMBO) &&
        requirementsSet.has(option._id)
      ) {
        menuIds.add(option._id);
        menuIds.add(menuObject._id);
      } else if (option._type === MenuObjectTypes.PICKER) {
        option.options.forEach((pickerOption: IPickerOption) => {
          if (requirementsSet.has(pickerOption.option._id)) {
            menuIds.add(option._id);
            menuIds.add(menuObject._id);
          }
        });
      } else if (option._type === MenuObjectTypes.PICKER_OPTION) {
        if (requirementsSet.has(option.option._id)) {
          menuIds.add(option.option._id);
        }
      }
    });

    return menuIds;
  }, new Set<string>());
};

export const getShouldShowMenuObjectBadge = (
  menuObject: MenuObject,
  requirementsSet: Set<string>
): boolean => {
  if (menuObject?._type === MenuObjectTypes.ITEM || menuObject?._type === MenuObjectTypes.COMBO) {
    return requirementsSet.has(menuObject?._id);
  } else if (menuObject?._type === MenuObjectTypes.PICKER) {
    // We will display the badge for a picker only if all the options for the picker are configured as the cart requirements
    const allOptionsArePresent = (menuObject.options || []).every(option =>
      requirementsSet.has(option.option._id)
    );
    return allOptionsArePresent;
  }
  return false;
};
